import template from './clientDashboard.html';
import controller from './clientDashboard.controller';
import './clientDashboard.less';

let clientDashboardComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default clientDashboardComponent;



// WEBPACK FOOTER //
// ./src/app/pages/clientDashboard/clientDashboard.component.js